class InsurancePermission {
  constructor(params) {
    this.isCheckRequired = params.isCheckRequired;
  }
}

export { InsurancePermission as default };
